module.exports = __webpack_public_path__ + "static/media/callIcon.30bda9f9_UI.svg";